import { useLanguage } from '../../../contexts/LanguageContext'

/**
 * Native mobile layout: no absolute positioning, single-column flow.
 */
export default function MobileSlideShell({ children }) {
  const { isRtl } = useLanguage()
  return (
    <div
      dir={isRtl ? 'rtl' : 'ltr'}
      className="flex w-full max-w-[640px] flex-col gap-6 px-5 pb-10 pt-20 mx-auto"
    >
      {children}
    </div>
  )
}
